import { DateHelper } from './../helpers/DateHelper';
import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent } from "../classes/BaseComponent";

@Component({
  selector: 'app-date-separator',
  templateUrl: './date-separator.component.html',
  styleUrls: ['./date-separator.component.scss']
})
export class DateSeparatorComponent extends BaseComponent implements OnInit {

  @Input() date = "";
  @Input() shouldDisplay;
  @Input() mode: string = "day";

  constructor() {
    super();
  }

  ngOnInit() {

    if(this.mode == "day") {
      let _date: string = DateHelper.serverDateToLocaleDate(this.date);

      let dayString: string = DateHelper.getDayString(this.date);
      if(dayString){
        _date = this.getString(dayString) + ", " + _date;
      }

      this.date = _date;
    }
    else if(this.mode == "month") {
      let _date: Date = DateHelper.dateStringToDateObject(this.date);
      if(!_date){
        return "";
      }
      let monthNumber: number = _date.getMonth();

      let monthsStrings = [
        "january",
        "february",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december"
      ];

      if(monthNumber >= 0) {
        this.date = this.getString(monthsStrings[monthNumber]);
      }

    }

  }

}
